import { FunctionalComponent, h } from 'preact';
import { WithStyles } from '../../../style';
import { ModalContext } from '../../../modal';
import { PromoCodeModal } from '../Modal/index';
import { connectWithStyles, BookingState } from '../../../store';
import { StoreProps, PromoCodeButtonProps } from './types';
import { FinText } from '../../../i18n';

const mapStateToProps = ({ selection }: BookingState): StoreProps => ({
  selection,
});

type EffectiveProps = PromoCodeButtonProps & WithStyles & StoreProps;

export const PromoCodeButton: FunctionalComponent<PromoCodeButtonProps> = connectWithStyles<PromoCodeButtonProps>([], {
  mapStateToProps,
})(({ selection, tx, class: extraClasses }: EffectiveProps, context: ModalContext) => {
  const openModal = () => {
    context.modal.showModal(<PromoCodeModal closeModal={() => context.modal.hideModal()} />);
  };

  const buttonText = selection.promoCode ? (
    <FinText id="promoCode.buttonWithCode" fields={{ code: selection.promoCode }} />
  ) : (
    <FinText id="promoCode.emptyButton" />
  );

  return (
    <button
      class={tx(
        `promo-code-button underline medium-type link-hover nordic-blue-900-text font-body-1 align-left ${extraClasses}`
      )}
      onClick={openModal}
    >
      {buttonText}
    </button>
  );
});
